const CLASS_NAMES = {
  in_stock: 'text-success',
  production: 'text-success',
  expected: 'text-warning',
  partial: 'text-warning',
};

const ICON_CLASS_NAMES = {
  in_stock: 'fa fa-check',
};

export const deliveryStatusClassName = (kind) => CLASS_NAMES[kind] ?? '';

export const deliveryStatusIconClassName = (kind) => ICON_CLASS_NAMES[kind] ?? null;
